// 收件人
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("recipients") || ""
}

const getters = {
  getRecipients:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("recipients",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("recipients")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
